/** Accept attribute for HEIC converter drop zones. */
export const HEIC_ACCEPT = '.heic,.heif,image/heic,image/heif';

/** Placeholder when browsers cannot preview HEIC input. */
export const HEIC_PLACEHOLDER_SVG = `data:image/svg+xml,${encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"><rect width="400" height="300" fill="#e4e4e7"/><text x="200" y="145" text-anchor="middle" font-family="system-ui,sans-serif" font-size="14" fill="#52525b">HEIC / HEIF</text><text x="200" y="168" text-anchor="middle" font-family="system-ui,sans-serif" font-size="12" fill="#71717a">Preview after conversion</text></svg>',
)}`;
